// @flow
import { postCreator } from '../../../../http';
import environment from '../../../../environment';

export type UploadImageResp = {
  +type: string;
  +id: string;
  +resourceGroup: string;
  +resourceId: string;
  +url: string;
};

export const endpoints = Object.freeze({
  UPLOAD_IMAGE: `${environment.apiUrl}/image/upload`,
  SET_ITEM_INVOICE: `${environment.apiUrl}/purchase/:orderId/:itemNumber/set-invoice`,
  SET_IDENTITY: `${environment.apiUrl}/purchase/:orderId/set-identity`,
  PROGRESS_PURCHASE: `${environment.apiUrl}/purchase/:orderId/progress/purchase`,
});

export const uploadImageApi = postCreator(fetch, endpoints.UPLOAD_IMAGE);
export const setItemInvoiceApi = postCreator(fetch, endpoints.SET_ITEM_INVOICE);
export const setIdentityApi = postCreator(fetch, endpoints.SET_IDENTITY);
export const progressPurchaseApi = postCreator(fetch, endpoints.PROGRESS_PURCHASE);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/register-purchase/api.js